import { Basic } from './Basic';
// import Event from './Event';

export default {
  Basic
  // Event
};
